// src/core/game.js
// Depends on: src/core/game/QuestionManager.js, src/core/game/GameUI.js

window.game = {
    // Oyunu Başlat (ASYNC — API'den soru çeker)
    startGame: async function () {
        // [GUVENLIK] Bağımlılık Kontrolü
        if (!window.audio || !window.QuestionManager || !window.GameUI || !window.ui) {
            console.error("GADDAR HATA: Kritik modüller (Audio, QuestionManager, GameUI, Router) yüklenemedi!");
            alert("Oyun dosyalarında eksiklik var. Lütfen sayfayı yenileyin.");
            return;
        }

        state.reset();

        const category = state.currentCategory;
        const modeKey = state.currentDifficulty;

        // 1. Soruları Seç (ASYNC — API öncelikli)
        // NOT: Önce soruları yükle, SONRA game-screen'e geç.
        // Çünkü Router, game-screen açılırken activeQuestions boşsa ana sayfaya yönlendiriyor.
        let questions;
        try {
            questions = await QuestionManager.selectQuestions(category, modeKey);
        } catch (e) {
            console.error('[Game] Soru yükleme hatası:', e);
            questions = [];
        }

        if (!questions || questions.length === 0) {
            alert("Soru bulunamadı!");
            ui.showScreen('category-screen');
            return;
        }

        // 2. Soruları state'e yaz (Router kontrolü geçsin diye ÖNCE yaz)
        state.activeQuestions = questions;

        // 3. Şimdi game-screen'e geç (activeQuestions dolu, Router izin verecek)
        ui.showScreen('game-screen');
        window.scrollTo({ top: 0, behavior: 'instant' });

        // 4. Müzik Başlat
        this.playCategoryMusic(category);

        // 5. Başla
        this.loadQuestion();
    },

    // CUSTOM GAME (Çark vb. için)
    startCustomGame: function (customQuestions, customMode = 'custom_wheel') {
        state.reset();
        state.currentCategory = customMode;
        state.activeQuestions = customQuestions; // Sorular dışarıdan geliyor
        state.isTimedMode = false;

        // Müzik Durdur (Çark müziği bitsin)
        if (customMode === 'custom_wheel') {
            audio.stopMusic();
        } else {
            // Karışık Müzik Çal
            audio.playMusic('düştük_tımarhaneye son versiyon.mp3', false);
        }

        ui.showScreen('game-screen');
        window.scrollTo({ top: 0, behavior: 'instant' });
        this.loadQuestion();
    },

    playCategoryMusic: function (cat) {
        if (cat === 'tarih') {
            audio.playMusic('ceddin_deden.mp3', true);
        } else if (cat === 'cografya') {
            audio.playMusic('gaddar_ile_cografya.mp3', true);
        } else if (cat === 'psikoloji') {
            audio.playMusic('gaddar_soru_3.mp3', true);
        } else if (cat === 'edebiyat') {
            audio.playMusic('HİCAZ KANUN TAKSİM - İBRAHİM ULUGERGERLİ (Kanun Solo) [Hvu-C-aP3Bs].mp3', true);
        } else if (cat === 'karisik') {
            audio.playMusic('düştük_tımarhaneye son versiyon.mp3', true);
        } else {
            audio.playMusic('gaddarin_pesindeyim.mp3', true);
        }
    },

    // Soruyu Yükle
    loadQuestion: function () {
        const q = state.activeQuestions[state.currentQuestionIndex];

        // Şıkları Hazırla (5 şık varsa 4'e düşür)
        QuestionManager.prepareQuestionOptions(q);

        // UI'ya çiz
        GameUI.displayQuestion(q, () => {
            // Yazma bittiğinde zamanlayıcıyı başlat (varsa)
            if (state.isTimedMode) {
                this.startTimer();
            }
        }, (selectedIndex) => {
            // Şıkk tıklanınca
            this.handleAnswer(selectedIndex);
        });
    },

    // Cevabı Kontrol Et
    handleAnswer: function (selectedIndex) {
        // EĞER OYUN EKRANI AKTİF DEĞİLSE İŞLEM YAPMA
        const gameScreen = document.getElementById('game-screen');
        if (!gameScreen.classList.contains('active')) return;

        // Zamanlayıcıyı durdur
        if (state.timer) clearInterval(state.timer);

        const q = state.activeQuestions[state.currentQuestionIndex];
        const isCorrect = (selectedIndex === q.correct);

        // UI Güncellemeleri (Renkler, Sesler)
        // Eğer süre bittiği için buraya geldiysek (-1), yanlış sesini çalma (sürebitti çaldı zaten)
        GameUI.handleAnswerVisuals(selectedIndex, q.correct, (selectedIndex === -1));

        // Puanlama
        if (isCorrect) {
            state.score += 10;
            state.correctAnswers++;
        } else {
            state.wrongAnswers++;
        }
        GameUI.updateScoreDisplay();

        // İlerleme
        state.currentQuestionIndex++;

        // Sonraki Soruye Geçiş (2sn bekle)
        setTimeout(() => {
            if (state.currentQuestionIndex < state.activeQuestions.length) {
                this.loadQuestion();
            } else {
                this.endGame();
            }
        }, 2000);
    },

    // Zamanlayıcı
    startTimer: function () {
        // Seçilen süreyi kullan veya varsayılan 15
        const timeLimit = state.timePerQuestion || 15;
        state.timeLeft = timeLimit;
        GameUI.updateTimer(state.timeLeft);

        state.timer = setInterval(() => {
            state.timeLeft--;
            GameUI.updateTimer(state.timeLeft);

            if (state.timeLeft <= 0) {
                clearInterval(state.timer);
                if (window.audio) window.audio.playSound('time_up');
                this.handleAnswer(-1); // Zaman bitti = Yanlış
            }
        }, 1000);
    },

    // Oyunu Yarım Bırak
    abortGame: function () {
        state.reset();
        GameUI.clearTypewriter();
        if (state.timer) clearInterval(state.timer);
    },

    // Oyunu Bitir
    endGame: function () {
        // Müzik dursun (Default mod)
        if (window.audio.musicMode !== 'custom') {
            audio.stopMusic();
        }

        // Puanları kaydet
        if (window.AuthManager && window.AuthManager.username) {
            window.AuthManager.addStats(state.score, state.correctAnswers, state.wrongAnswers);
        }

        GameUI.showEndGameScreen(state.score, state.correctAnswers, state.wrongAnswers, state.currentCategory);
    }
};
